import { initializeIconDefinitions } from './iconDefinitions';
import { initializeShapeAndMarkerDefinitions } from './shapeAndMarkerDefinitions';

/**
 * Initializes icon, shape and marker definitions.
 */
export const initializeGraphicAssets = () => {
  initializeShapeAndMarkerDefinitions();
  initializeIconDefinitions();
};
